import PropTypes from "prop-types"
import { get, map, first } from "lodash"
import { Grid } from "@mui/material"
import ItemCell from "./item-cell"

export default function TitleRow({ columns, data, items, cellWidth, getBackgroundColor }) {
  return <Grid container item className="title-row">
    {map(columns, ({ color, noData, isUnmodeled }, i) => {
      const loading = !data[i] && !noData && !isUnmodeled
      const item = first(get(items, i)) ?? {}
      return <ItemCell
        key={`title-col${i}`}
        loading={loading}
        className="group-column"
        item={item}
        width={cellWidth}
        color={color}
        style={getBackgroundColor(loading, color)}
      />
    })}
  </Grid>
}

TitleRow.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    noData: PropTypes.bool,
    isUnmodeled: PropTypes.bool,
  })).isRequired,
  items: PropTypes.array.isRequired,
  data: PropTypes.array,
  cellWidth: PropTypes.number.isRequired,
  getBackgroundColor: PropTypes.func.isRequired,
}
